import BaseApi from '@/api/controller/base';

const LOOKUP_API_URL = 'lookups/';

class LookupApi extends BaseApi {
  constructor() {
    super(LOOKUP_API_URL);
  }

  departments() {
    return this.api.get('departments');
  }

  USStates() {
    return this.api.get('USStates');
  }

  offices() {
    return this.api.get('offices');
  }

  earlyBirdEnrollmentTypes() {
    return this.api.get('earlyBirdEnrollmentTypes');
  }

  referralStates() {
    return this.api.get('referralStates');
  }
}

const apiInstance = new LookupApi();
export { LookupApi, apiInstance };
export default apiInstance;
